import LandingNavigation from './LandingNavigation';

export default LandingNavigation;
